'use client';

import Cookies from 'js-cookie';
import { useEffect } from 'react';

const RETURNING_USER_COOKIE = 'falkor-returning-user';

/**
 * The returning user cookie helper tracks user visits:
 * - First visit: sets cookie to 'false'
 * - Second visit: upgrades cookie to 'true'
 * - Subsequent visits: cookie remains 'true'
 *
 * This allows variant targeting based on returning user status.
 *
 * @returns null
 */
const ReturningUserCookie = () => {
  useEffect(() => {
    const returningUserCookie = Cookies.get(RETURNING_USER_COOKIE);

    if (!returningUserCookie) {
      // First visit: set to false
      Cookies.set(RETURNING_USER_COOKIE, 'false', { expires: 365 });
    } else if (returningUserCookie === 'false') {
      // Second visit: upgrade to true
      Cookies.set(RETURNING_USER_COOKIE, 'true', { expires: 365 });
    }
    // If already 'true', do nothing
  }, []);

  return null;
};

export default ReturningUserCookie;
